export default __webpack_public_path__ + "static/custom-marker-shapes-f71e0e8927b42493fd9562840a3c0880.png";